class UserController {
    constructor($state, $location) {
        if($location.path() === '/user') {
            $state.go('user.list');
        }
    }
}

export default UserController;



// WEBPACK FOOTER //
// ./src/app/pages/user/userController.js